import styled from '@emotion/styled';
import {mixinFocus} from 'webapp-lib/styling';

import ListItem from '#/List/Item';
import Placeholder from '#/Placeholder';
import SearchBar from '#/SearchBar';
import {
  Dropdown,
  Header,
  IconWrapper,
  StyledSelectBox,
} from '#/form/selectable-input/SelectBox/styles';

export const FilterSelectBoxStyle = styled(StyledSelectBox)`
  font-size: var(--font-size-small);
  color: var(--color-core-link);
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;

  :hover&:not([aria-selected='true'])&:not(:disabled) {
    background-color: var(--color-state-hover);
  }

  :hover&:not(:disabled) {
    background-color: var(--color-state-active);
  }

  :disabled {
    color: var(--input-color-disabled);
  }

  :focus {
    z-index: var(--zindex-elevated);
    ${mixinFocus}
  }

  ${Dropdown} {
    width: 288px;
  }

  ${Placeholder} {
    svg {
      height: 120px;
      width: auto;
    }
  }

  ${SearchBar} {
    svg {
      fill: var(--color-state-active);
    }
  }

  ${ListItem} {
    color: var(--color-core-link);

    :hover {
      color: var(--color-core-white);
      background-color: var(--color-state-active);
    }
  }

  ${Header} {
    display: flex;
    flex: 1;
    padding: 0px var(--gutter-small);
    height: 100%;

    > ${IconWrapper} {
      padding: var(--gutter-tiny);

      > svg {
        fill: ${({disabled}): string =>
          disabled ? 'var(--input-color-disabled)' : 'var(--color-core-link)'};
      }
    }
  }
`;

/**
 * @deprecated use ETableFilterScaffold instead
 */
export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  // Add margins to show whole focus when filter is selected
  margin: var(--gutter-very-tiny) 0 var(--gutter-little) var(--gutter-very-tiny);
  gap: var(--gutter);
`;

export const ResetButton = styled.button`
  width: fit-content;
  height: var(--height-small-button);
  padding: var(--button-small-spacing-inner);
  border: unset;
  color: var(--color-core-link);
  font-weight: var(--font-weight-filter-button);
  font-size: var(--font-size-small);
  cursor: ${({disabled}): string => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  background-color: var(--color-core-white);

  :focus {
    ${mixinFocus}
  }
`;
